module.exports = __webpack_public_path__ + "static/img/G.87bdfc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lll/G.png
// module id = e7NG
// module chunks = 0